require(
  [
    'aboutInitializer',
  ]
);

define("nhs/views/BuilderShowCaseRedesign/ShowAbout", function(){});

